import {
  ActionSlot,
  actionSlotRepository,
  battleCardsDefRepository,
  cardsDefRepository,
  FactionType,
  intrigueCardsDefRepository,
} from "~/business";
import { playerLeaderRepository } from "~/business/constant/playerLeaders";
import { techTiles } from "~/business/TechTile";
import {
  XAcquireTechCard,
  XActionSlot,
  XAgentEffect,
  XBattleCard,
  XBattleCardBack,
  XBeneGesseritSvg,
  XCard,
  XCardBack,
  XCardIconSvg,
  XCityActionSvg,
  XCombatPointSvg,
  XCrossedSwordsSvg,
  XCubeSvg,
  XEmperorSvg,
  XFactionChange,
  XFoldspaceSvg,
  XFremenSvg,
  XGuildSvg,
  XHourglassSvg,
  XInfluentPointSvg,
  XIntrigueCard,
  XIntrigueCardSvg,
  XLandsraadActionSvg,
  XMeaple,
  XMeapleSlotSvg,
  XMeapleSvg,
  XOpponentInfos,
  XOpponentSolaris,
  XPackBy,
  XSignetSvg,
  XSolarisSvg,
  XSpiceActionSvg,
  XSpiceSvg,
  XStealIntrigueSvg,
  XTechTile,
  XTrashMeSvg,
  XVictoryPointSvg,
  XWaterSvg,
} from "~/jsx/components/design";
import { Sizes, Spacing } from "~/jsx/theme";
import { groupBy } from "~/utils";
import { XFreighterRampTester } from "../design/XFreighterRampTest";
import { XFactionRampTester } from "./XFactionRampTester";
import { newPlayerFactory } from "~/business/newPlayerFactory";

export const XStorybook = () => {
  const actionSlots = actionSlotRepository.entities;
  const groupedActionSlots = groupBy(actionSlots, (slot) => slot.agentIcon);
  const card = cardsDefRepository.fromName("Signet ring");
  const battleCard = battleCardsDefRepository.fromDef(
    battleCardsDefRepository.entities[0]
  );
  const meapleSizes = [18, 24, 36, 64, 128];

  return (
    <div>
      <XOpponentSolaris personalAmount={5} opponentAmount={1} width={32} />
      <XFreighterRampTester />
      <XAcquireTechCard width={150} discount={2} />
      <XPackBy packSize={5} gap={Spacing.px8}>
        {techTiles.map((techTile) => (
          <XTechTile key={techTile.id} techTile={techTile} />
        ))}
      </XPackBy>
      <div>
        {playerLeaderRepository.entities.map(
          ({ signetRing, globalEffect: gameStartEffect }, index) => (
            <div key={index} style={{ border: "solid 1px black" }}>
              <XAgentEffect
                effectDescription={signetRing}
                width={32}
                color="black"
                context="card"
              />
              {gameStartEffect && (
                <XAgentEffect
                  effectDescription={gameStartEffect}
                  width={32}
                  color="black"
                  context="card"
                />
              )}
            </div>
          )
        )}
      </div>
      {meapleSizes.map((size) => (
        <XMeaple
          key={size}
          meaple={{ id: "plop", owner: "plop" }}
          width={size}
        />
      ))}
      {meapleSizes.map((size) => (
        <XMeaple key={size} width={size} />
      ))}
      <XIntrigueCard
        width={Sizes.intrigueCard.width}
        card={intrigueCardsDefRepository.fromName(
          intrigueCardsDefRepository.entities[0].name
        )}
      />
      <div style={{ display: "flex" }}>
        <XFactionChange width={48} change={1} />
        <XFactionChange width={48} change={2} />
        <XFactionChange width={48} change={-1} />
      </div>
      {Object.values(FactionType).map((faction) => (
        <div key={faction} style={{ display: "flex" }}>
          <XFactionChange faction={faction} width={48} change={1} />
          <XFactionChange faction={faction} width={48} change={2} />
          <XFactionChange faction={faction} width={48} change={-1} />
        </div>
      ))}
      <XHourglassSvg width={48} />
      <XStealIntrigueSvg width={48} />
      <XSignetSvg width={48} />
      <XFoldspaceSvg width={48} />
      <XTrashMeSvg width={48} />
      <XEmperorSvg width={48} />
      <XBeneGesseritSvg width={48} />
      <XGuildSvg width={48} />
      <XFremenSvg width={48} />
      <div style={{ margin: "10px", display: "flex", gap: 10 }}>
        <XCardBack width={150} />
        <XCard card={card} width={150} />
      </div>
      <div style={{ margin: "10px", display: "flex", gap: 10 }}>
        <XBattleCard card={battleCard} />
        {[...new Array(3)].map((_, index) => (
          <XBattleCardBack key={index} level={index + 1} />
        ))}
      </div>
      <div style={{ margin: "10px" }}>
        <XFactionRampTester playerCount={2} />
        <XFactionRampTester playerCount={3} />
        <XFactionRampTester playerCount={4} />
      </div>
      <div style={{ margin: "10px" }}>
        <XOpponentInfos
          player={newPlayerFactory()}
          isCurrent={true}
          isFirst={false}
        />
      </div>
      <div>
        <XWaterSvg width={48} />
        <XSolarisSvg width={48} />
        <XSpiceSvg width={48} />
        <XCardIconSvg width={48} />
        <XMeapleSvg width={48} />
        <XMeapleSlotSvg width={48} />
        <XCombatPointSvg width={48} />
        <XVictoryPointSvg width={48} />
        <XCrossedSwordsSvg width={48} />
        <XCubeSvg width={48} color="#C41414" />
        <XCubeSvg width={48} color="blue" />
        <XCubeSvg width={48} color="green" />
        <XCubeSvg width={48} color="yellow" />
        <XIntrigueCardSvg width={48} />
        <XInfluentPointSvg width={48} />
        <XSpiceActionSvg width={48} />
        <XLandsraadActionSvg width={48} />
        <XCityActionSvg width={48} />
      </div>
      <div
        style={{
          marginLeft: 10,
          display: "flex",
        }}
      >
        <XCard card={card} width={180} />
        <XCard card={card} width={150} />
        <XCard card={card} width={100} />
        <XCard card={card} width={80} />
      </div>
      <XPackBy packSize={10}>
        {cardsDefRepository.entities.map((cardDef) => {
          return (
            <XCard
              key={cardDef.name}
              card={cardsDefRepository.fromName(cardDef.name)}
              width={150}
            />
          );
        })}
      </XPackBy>
      <XPackBy packSize={10}>
        {intrigueCardsDefRepository.entities.map((cardDef) => {
          const card = intrigueCardsDefRepository.fromName(cardDef.name);
          return (
            <XIntrigueCard
              card={card}
              width={Sizes.intrigueCard.width}
              key={cardDef.name}
            />
          );
        })}
      </XPackBy>
      <XPackBy packSize={10}>
        {battleCardsDefRepository.entities.map((cardDef) => {
          const card = battleCardsDefRepository.fromDef(cardDef);
          return <XBattleCard card={card} key={cardDef.id} />;
        })}
      </XPackBy>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {Object.values(groupedActionSlots).map((group, index) => (
          <div key={index} style={{ display: "flex", gap: "10px" }}>
            {group.map((actionSlot, index) => (
              <XActionSlot
                key={index}
                actionSlot={ActionSlot.from(actionSlot)}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default XStorybook;
